import {
  COMMON_LOAD_FORM_DATA_BEGIN,
  COMMON_LOAD_FORM_DATA_SUCCESS,
  COMMON_LOAD_FORM_DATA_FAILURE,
  COMMON_LOAD_FORM_DATA_DISMISS_ERROR,
} from './constants'

import { getEndpoint } from '../backend/endpoints'
import axios from 'axios'
import { castNumbersInObj } from '../Utilities'

export function loadFormData({ id, source, concesionarioId, prevState = {} } = {}) {
  return (dispatch) => {
    dispatch({
      type: COMMON_LOAD_FORM_DATA_BEGIN,
    })

    const endpoint = getEndpoint(source)

    const promise = new Promise((resolve, reject) => {
      // si id o source llega nulo a este punto es porque hay un error de logica
      // en la programación. revisar porque llega un id vacio en vez de eliminar
      // la condición o el rechazo de la promesa acá
      const url = concesionarioId 
                  ? `${endpoint}/${id}?car_lot_id=${concesionarioId}` 
                  : `${endpoint}/${id}`

      const doRequest =
        id && endpoint
          ? axios(url)
          : Promise.reject(new Error('Proporcionar id o source al cargar datos de item'))
      doRequest.then(
        (res) => {
          // control para editar el product_id del stock en Producto
          // para la UH 48449 - se pidió no hacer cambios desde el back
          const itemData = (res.data.data.Stocks && res.data.data.Stocks.length > 0 && res.data.data.nuevo === false)
            ? {...prevState, ...{...res.data.data, location_id: res.data.data.Stocks[0].location_id}}
            : {...prevState, ...res.data.data}
          castNumbersInObj(itemData, [
            'precio_lista',
            'bonficacion',
            'flete_alistaje',
            'accessory_1',
            'accessory_2',
          ])
          dispatch({
            type: COMMON_LOAD_FORM_DATA_SUCCESS,
            data: {
              itemData,
            },
          })
          resolve(itemData)
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: COMMON_LOAD_FORM_DATA_FAILURE,
            data: { error: err },
          })
          reject(err)
        },
      )
    })

    return promise
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissLoadFormDataError() {
  return {
    type: COMMON_LOAD_FORM_DATA_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_LOAD_FORM_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        loadFormDataPending: true,
        loadFormDataError: null,
      }

    case COMMON_LOAD_FORM_DATA_SUCCESS:
      // The request is success
      return {
        ...state,
        loadFormDataPending: false,
        loadFormDataError: null,
        formData: {
          ...state.formData,
          ...action.data,
        },
      }

    case COMMON_LOAD_FORM_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        loadFormDataPending: false,
        loadFormDataError: action.data.error,
      }

    case COMMON_LOAD_FORM_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        loadFormDataError: null,
      }

    default:
      return state
  }
}
